// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sign-up-success-container
{
    padding-bottom: 100px;
}

#sign-up-success-title
{
    display: flex;
    justify-content: center;
}

#sign-up-success-title p
{
    color: white;
    font-weight : 600;
    font-size : clamp(21px, 3vw, 40px);
    text-align: center;
    margin-top : 4%;
    padding: 0px 10px;
}

#sign-up-success-description
{
    display: flex;
    justify-content: center;
}

#sign-up-success-description p
{
    color: white;
    padding : 30px;
    font-weight : 500;
    font-size : clamp(16px, 1.5vw, 26px);
    text-align: center;
    line-height: 45px;
}

#sign-up-success-button-container
{
    display: flex;
    justify-content: center;
}

#sign-up-success-button
{
    color: white;
    background-color: var(--dark-secondary-color);
    font-size : clamp(1.6vw, 1.8vw, 1.8vw);
    font-weight : 600;
    text-decoration: none;
    border-radius: 30px;
    cursor: pointer;
    padding: 10px 20px;
    margin-top : 4%;
    text-align: center;
    transition : all 0.3s ease-in-out;
}

#sign-up-success-button:hover
{
    background-color : var(--secondary-color);
}

@media all and (max-width : 850px)
{
    #sign-up-success-container
    {
        padding-top: 90px;
    }
}

@media all and (max-width : 780px)
{
    #sign-up-success-description p
    {
        line-height: 30px;
    }

    #sign-up-success-button
    {
        font-size : 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/explore-services/signup-success.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;IACZ,6CAA6C;IAC7C,sCAAsC;IACtC,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":["#sign-up-success-container\n{\n    padding-bottom: 100px;\n}\n\n#sign-up-success-title\n{\n    display: flex;\n    justify-content: center;\n}\n\n#sign-up-success-title p\n{\n    color: white;\n    font-weight : 600;\n    font-size : clamp(21px, 3vw, 40px);\n    text-align: center;\n    margin-top : 4%;\n    padding: 0px 10px;\n}\n\n#sign-up-success-description\n{\n    display: flex;\n    justify-content: center;\n}\n\n#sign-up-success-description p\n{\n    color: white;\n    padding : 30px;\n    font-weight : 500;\n    font-size : clamp(16px, 1.5vw, 26px);\n    text-align: center;\n    line-height: 45px;\n}\n\n#sign-up-success-button-container\n{\n    display: flex;\n    justify-content: center;\n}\n\n#sign-up-success-button\n{\n    color: white;\n    background-color: var(--dark-secondary-color);\n    font-size : clamp(1.6vw, 1.8vw, 1.8vw);\n    font-weight : 600;\n    text-decoration: none;\n    border-radius: 30px;\n    cursor: pointer;\n    padding: 10px 20px;\n    margin-top : 4%;\n    text-align: center;\n    transition : all 0.3s ease-in-out;\n}\n\n#sign-up-success-button:hover\n{\n    background-color : var(--secondary-color);\n}\n\n@media all and (max-width : 850px)\n{\n    #sign-up-success-container\n    {\n        padding-top: 90px;\n    }\n}\n\n@media all and (max-width : 780px)\n{\n    #sign-up-success-description p\n    {\n        line-height: 30px;\n    }\n\n    #sign-up-success-button\n    {\n        font-size : 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
